import ApiConnector from '@/models/ApiConnector';
import ApiModel     from '@widesk-core/models/ApiModel';
import config       from '@/config';

export const gespassConnector = new ApiConnector({
	baseURL: config.api_endpoint + `/gespass`,
});

export default class GespassServiceModel extends ApiModel {
	public static get connector() {
		return gespassConnector;
	}

	public static serviceName = 'gespass';
	public static partitionName = 'jts';
}
